import { Link } from 'react-router-dom';
import { v4 as uuid4 } from 'uuid';
import { recommendedArtists, subscriptions } from '../../test.data';
import { TinyUser } from '../../types/userProfile';
import AltAvatar from '../images/alt-avatar';
import { VStack } from '../layouts/stack.layout';
import Container from './container';

type SubscriptionsQuery = 'TRACKING' | 'LIVE' | 'RECOMMENDED';

type Props = {
  trigger: Function;
  query: SubscriptionsQuery[];
};

export default function SubscriptionsContainer({ trigger, query }: Props) {
  const data: Array<TinyUser & { displayName: string }> = [];

  // temporary data querying from local data store
  if (query) {
    for (const q of query) {
      data.push(...GET[q]());
    }
  }

  // const sortedData = data.sort(
  //   (a: ReleaseItem, b: ReleaseItem) =>
  //     convertDateToX(a.date, 'll') - convertDateToX(b.date, 'll')
  // );

  return (
    <section className="my-2 mobile:px-2 tablet-lg:px-[40px]" key={uuid4()}>
      <Container extensions="grid mobile:grid-cols-4 tablet-sm:grid-cols-6 laptop:grid-cols-4 gap-5 tablet-lg:px-0">
        {data.map((artist: TinyUser & { displayName: string }) => (
          <div className="justify-stretch" key={uuid4()}>
            <Link className="w-full" to={`/${artist.username}`}>
              <VStack gap="sm" extensions="w-full items-center">
                <AltAvatar url={artist.avatarUrl} />
                <div className="font-text text-center text-xs font-medium text-primary">
                  {artist.displayName}
                </div>
              </VStack>
            </Link>
          </div>
        ))}
      </Container>
    </section>
  );
}

type SubscriptionsQueryMap = { [key in SubscriptionsQuery]: Function };

const GET: SubscriptionsQueryMap = {
  LIVE: (): Array<TinyUser & { displayName: string }> => {
    return subscriptions.slice(0, 2);
  },

  RECOMMENDED: (): Array<TinyUser & { displayName: string }> => {
    return recommendedArtists;
  },

  TRACKING: (): Array<TinyUser & { displayName: string }> => {
    return subscriptions;
  },
};
